import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createVNode as _createVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "border p-4 text-2xl border-gray-200 rounded-lg my-4" }, " Seçtiğiniz iletişim bilgileri, potansiyelin iletişim bilgileri olarak otomatik şekilde eklenecektir. Diğer bilgileri daha sonra potansiyel sayfasından düzenleyebilirsiniz. ", -1)
const _hoisted_2 = { class: "flex justify-between items-center" }
const _hoisted_3 = { class: "ac-form-control w-3/4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "potentialName" }, "Potansiyel Adı", -1)
const _hoisted_5 = { class: "ac-form-control mt-8" }
const _hoisted_6 = { class: "ac-form-control" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", { for: "potentialType" }, "Potansiyel Tipi", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("option", { value: "company" }, "Şirket", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("option", { value: "individual" }, "Bireysel", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = { class: "ac-button-row justify-center gap-4 flex" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "ac-primary-button"
}, "Potansiyel Oluştur", -1)

import { ref } from "vue"
import StarPicker from "@/components/reusable/starPicker.vue"
import type { AcContactData } from "@/types/crm"

export default /*#__PURE__*/_defineComponent({
  __name: 'addPotentialFromEmail',
  props: ["email"],
  emits: ["potential-added", "cancel"],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit


const potentialName = ref("")
const potentialType = ref<"company" | "individual" | null>(null)
const potentialRating = ref(0)

const emitPotentialAdded = () => {
    const contactInformation: AcContactData = {
        title: "Genel",
        emailAddress: props.email.email,
        phoneNumber: props.email.phone,
        address:"",
        website: props.email.companyUrl,
    }

    
    emit("potential-added", {
        title: potentialName.value,
        type: potentialType.value,
        potentialRating: potentialRating.value,
        contact: [contactInformation],
    })
}

const cancel = () => {
    emit("cancel")
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(emitPotentialAdded, ["prevent"]),
    class: "ac-main-form !border-none !shadow-none"
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          type: "text",
          id: "potentialName",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((potentialName).value = $event)),
          required: ""
        }, null, 512), [
          [_vModelText, potentialName.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(StarPicker, {
          "onUpdate:pickedQuantity": _cache[1] || (_cache[1] = ($event: any) => (potentialRating.value = $event)),
          modelValue: potentialRating.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((potentialRating).value = $event)),
          maxQuantity: 5,
          pickedQuantity: potentialRating.value
        }, null, 8, ["modelValue", "pickedQuantity"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createElementVNode("select", {
        class: "py-3",
        id: "potentialType",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((potentialType).value = $event)),
        required: ""
      }, _hoisted_10, 512), [
        [_vModelSelect, potentialType.value]
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _hoisted_12,
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (cancel())),
        class: "ac-secondary-button"
      }, "İptal")
    ])
  ], 32))
}
}

})